import React, { memo as Memo, useState, useEffect, useCallback, useRef } from 'react';
import { withUserContext, withUIContext } from 'context';
import { useRouter } from 'next/router';

//* Components
import { Text, LikeDislike, CommentsCount, Icon, CustomLink, Avatar } from 'components/common';
import { Comments, SubmitReportPopup } from 'components/pages';
import { Input as BaseInput } from 'antd';
import LikeSystem from './LikeSystem';

//* Style
import SingleConProStyle from './style'
import AnimateHeight from 'react-animate-height'

const SingleConPro = Memo(({ openPopup, ...props }) => {
    const [inputValue, setInputValue] = useState('')
    const [toggleHgt, setToggleHgt] = useState(0)
    const [reportPopup, setReportPopup] = useState(false)

    const inputRef = useRef()
    const router = useRouter()

    useEffect(() => {
        if (reportPopup) {
            document.addEventListener('click', clickHandler)
        }

        return () => {
            document.removeEventListener('click', clickHandler)
        }
    }, [reportPopup])

    const clickHandler = useCallback((e) => {
        if (!(!!e.path.find((el) => el.classList?.contains('icon-pop')))) {
            let isExist = e?.path.find(el => el.classList?.contains('pop'));

            if (!isExist) {
                setReportPopup(false)
            }
        }
    }, []);

    const addComment = (e) => {
        if (!props.isLoggedIn) {
            router.push(`${router.asPath}?c=login`)
        } else {
            if (inputValue.length > 0) {
                return props.addComment({
                    feedback_id: props.feedbackId,
                    debate_id: props.debateId,
                    text: e.target.value
                }).then(() => {
                    setInputValue('')
                })
            }
        }
    }

    const replyComment = (name) => {
        setInputValue(`@${name} `)
        inputRef.current.focus()
    }

    const handleReportPopUp = () => {
        if (!props.isLoggedIn) {
            router.push(`${router.asPath}?c=login`)
        } else {
            openPopup(<SubmitReportPopup />, {
                title: props.title,
                url: router.asPath
            })
        }
    }

    return (
        <SingleConProStyle className='flexBoxColumn'>
            {props.isChild ? (
                <Text tag={'h5'} className='title h5 PopReg newLineText' text={props.title} />
            ) : (
                <CustomLink url={`/feedback/${props.feedbackId}`}>
                    <Text tag={'h5'} className='title h5 PopReg newLineText' text={props.title} />
                </CustomLink>
            )}

            <div className='footer flexBox'>
                <LikeSystem {...props} />
                {!props.isChild && (
                    <LikeDislike liked={props.proCount} disliked={props.conCount} />
                )}
                <CommentsCount onClick={() => setToggleHgt(toggleHgt === 0 ? 'auto' : 0)} commentsCount={props.commentsCount} />
                <div className='author flexBox alignMiddle'>
                    <Avatar src={props.user.avatar} />
                    <div className='report blockk flexBox alignMiddle'>
                        <Icon
                            className='darkGrey cursorPointer op-burgerDots icon-pop'
                            onClick={() => setReportPopup(!reportPopup)}
                        />
                        <div className={`report-popup pop flexBoxColumn ${reportPopup ? 'active' : ''}`}>
                            {props.user.id != props.currentUser?.id && (
                                <Text
                                    tag='h5'
                                    className='sharer PopReg h5 cursorPointer'
                                    text='Report'
                                    onClick={handleReportPopUp}
                                />
                            )}
                            <CustomLink url={`/${props.user.username}`}>
                                <Text tag='h5' className='sharer PopReg h5' text='Go to creators page' />
                            </CustomLink>
                        </div>
                    </div>
                </div>
            </div>
            <AnimateHeight duration={500} height={toggleHgt}>
                <div className='head flexBox spaceBetween alignMiddle'>
                    <Text tag={'h5'} className='h5 PopSemi' text={'Comments'} />
                    <Icon onClick={() => setToggleHgt(0)} className='op-close cursorPointer' />
                </div>
                <Comments
                    pusher={props.pusher}
                    feedbackId={props.feedbackId}
                    comments={props.comments}
                    replyComment={replyComment}
                    isFinished={props.isFinished}
                />
                {!props.isFinished && (
                    <BaseInput
                        ref={inputRef}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onPressEnter={addComment}
                        className="input-text"
                        placeholder={'Tell what you think...'}
                    />
                )}
            </AnimateHeight>
        </SingleConProStyle>
    )
})

export default withUserContext(withUIContext(SingleConPro, ['openPopup']), ['addComment', 'isLoggedIn', 'currentUser'])
